import { filterToQueryParams } from '../utils';
import { request } from '../request';
import { Filter } from '@libs/store/filters';
import { PaginatedResponse } from '@libs/models/common';
import { TemplateListItem } from '@libs/models/shiftTemplates';

export type GetTimecardsParams = {
  orderBy?: { key: string; sort: string }[];
  search?: string;
  page?: number;
  size?: number;
  filters?: Record<string, Filter>;
};
export async function fetchShiftTemplatesList(
  params?: GetTimecardsParams,
): Promise<PaginatedResponse<TemplateListItem[]>> {
  const filters = filterToQueryParams(params?.filters ?? {}, {
    removeEmpty: true,
    renameMap: { qualifications: 'nurseQualifications' },
  });
  const response = await request.get<TemplatesListItemResponse[]>('/v2/templates/shifts', {
    params: {
      search: filters?.search_in ?? params?.search,
      ...filters,
    },
  });
  return {
    items: response.data.map((item) => ({
      ...item,
      recurrence: item.recurrenceType.toLowerCase(),
      recurrenceType: item.recurrenceType.toLowerCase() as 'single' | 'series' | 'rotation',
      specialty: item.speciality
        ? {
            id: item.speciality.id,
            name: item.speciality.title,
            category: item.speciality.category,
          }
        : null,
    })),
    totalCount: response.data.length,
    pageNumber: 0,
    pageSize: response.data.length,
  };
}

type TemplatesListItemResponse = {
  id: string; // 'shifttemplate-00000000000000000000000000';
  name: string;
  shiftTimePresetTemplate: {
    id: string; //'shifttimepresettemplate-00000000000000000000000000';
    name: string;
    startTime: string; //'00:00:00';
    durationInSeconds: number;
  };
  recurrenceType: 'single' | 'series' | 'rotation';
  startTime: string; // '00:00:00';
  durationInSeconds: number;
  durationInDays: number;
  seriesRecurrence: string;
  rotationRecurrence: string;
  departmentNode: {
    id: string; // 'departmentnode-00000000000000000000000000';
    label: string;
  };
  subDepartmentNode: {
    id: string; // 'departmentnode-00000000000000000000000000';
    label: string;
  };
  speciality: {
    id: string; // 'speciality-00000000000000000000000000';
    title: string;
    category: string;
  };
  qualifications: [
    {
      id: string;
      name: string;
      abbreviation: string;
      category: string;
    },
  ];
  tags: string[];
  location: {
    id: string; // 'location-00000000000000000000000000';
    name: string;
  };
};
